import { lazy, Suspense } from "react";

import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/paymentHistory/main"));

const PaymentHistory = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default PaymentHistory;